<template>
    <div>
        <div class="WebsiteDesign">
            <form @submit.prevent="onSubmit()">
                <div class="WebsiteDesign__header" :class="{jsComplete:complete}" aria-hidden="true" style="display: none">
                    <div class="WebsiteDesign__title">
                        {{ name }}
                    </div>
                    <div class="WebsiteDesign__completion">
                        <v-switch @click.stop="toggleComplete"
                                  v-model="complete"
                                  :loading="completing"
                                  :disabled="completing"
                                  :color="switchColor()"
                                  class="customColor"
                                  inset
                        ></v-switch>
                    </div>
                </div>
                <div class="WebsiteDesign__content" :class="{jsExpanded:expanded}">
                    <div class="WebsiteDesign__text">
                        <div v-for="(field, id) in fields"
                             :key="namespace+field.id+id"
                        >
                            <Field v-if="field.id"
                                   :field-id="field.id"
                                   :card-namespace="namespace"
                                   :key="namespace+field.id+id"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import store from '../../../store/store';
import axios from 'axios';
import Field from '../Field/Field';
import { EventBus } from '@/store/eventBus';

export default {
    components: { Field },
    props: [
        'name',
        'cardHasData',
        'loaded',
        'namespace',
        'fields',
    ],

    computed: {
        complete: {
            get: function() {
                return store.state[this.namespace].complete;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setComplete`, value);
            }
        },

        completing: {
            get: function() {
                return store.state[this.namespace].completing;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setCompleting`, value);
            }
        },
    },

    data() {
        return {
            expanded: true,
        };
    },

    mounted() {
        EventBus.$on('SaveCard', () => {
            //this.onSubmit();
        });
    },

    methods: {
        toggleComplete() {
            store.dispatch(`${this.namespace}/setComplete`);
        },

        switchColor() {
            if (this.complete === true) {
                return 'white';
            }
        },

        onSubmit() {
            let fields = [];

            this.fields.forEach((field) => {

                const entry = store.getters[`field-user-${field.id}/entry`];
                fields.push({
                    id: field.id,
                    entry: entry
                });
            });

            let postData = { 'fields': fields };
            axios.post('/api/submission/store', postData)
                .then(() => {});
        }
    }
};
</script>

<style lang="scss">
    .WebsiteDesign {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;

        form {
            display: flex;
            flex-flow: row wrap;
            flex: 0 0 100%;
            width: 100%;
        }
    }

    .WebsiteDesign__header {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        width: 100%;
        flex: 0 0 100%;

        .v-input--switch.v-input--is-dirty.v-input--is-disabled {
            opacity: 1 !important;

            .v-input--selection-controls__input .v-input--switch__thumb {
                //color: #fff !important;
            }

            .v-input--selection-controls__input .v-input--switch__track {
                color: #fff !important;
            }
        }

        .customColor .v-input--selection-controls__input div {
            color: $primary-500;
        }
    }

    .WebsiteDesign__text,
    .WebsiteDesign__actions {
        flex: 0 0 100%;
        width: 100%;
    }

    .WebsiteDesign__actions {
        display: flex;
        justify-content: flex-end;
        padding-top: 0;
    }

    .WebsiteDesign__content {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
        height: 0;
        overflow: hidden;

        &.jsExpanded {
            height: auto;
            overflow: visible;
        }
    }

    .WebsiteDesign__title {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        flex: 1 1 auto;
        width: auto;
        text-align: left;
        font-size: 1.2rem;
        font-weight: bold;
    }

    .WebsiteDesign__toggle {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        padding-right: 12px;
    }

    .WebsiteDesign__completion {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        flex: 0 0 100px;
        width: 100px;
        margin-left: auto;
    }

    .WebsiteDesign__header {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        width: 100%;
        flex: 0 0 100%;

        &.jsComplete {
            background-color: $primary-500 !important;

            .WebsiteDesign__title {
                color: white;
            }
        }
    }
</style>
